module.exports = __webpack_public_path__ + "img/Dantam Fashion 17.072fa4ad.jpg";